import React, { Fragment, Component } from 'react';
import { Grid, } from '@material-ui/core';

import { Announcement } from '@material-ui/icons';
import { Description } from '@material-ui/icons';
import { Event } from '@material-ui/icons';
import { Link } from '@material-ui/icons';
import { RssFeed } from '@material-ui/icons';
import { Subject } from '@material-ui/icons';

import Overview from './home/Overview';
import DetailsCardModal from './containers/DetailsCardModal';
import { NoticeDetail } from './NoticeDetail';
import { EventDetail } from './EventDetail';
import { GeneralAlertDetail } from './GeneralAlertDetail';

import { Filters } from '../services/Filters';

const _filters = new Filters();

class Home extends Component {
  
  state = {
    open: false,
  }

  handleNoticeItemSelect = (id) => {
    this.props.handleNoticeItemSelected(id);
    this.handleOpen();   
  }

  handleAlertItemSelect = (id) => {
    this.props.handleAlertItemSelected(id)
    this.handleOpen();
  }

  handleEventItemSelect = (id) => {
    this.props.handleEventItemSelected(id)
    this.handleOpen();
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    // this.props.onClose();
    this.setState({ open: false });
  };
    
  render() {

    const {
      translations,
      appLanguage,
      generalAlerts,
      alertItem,
      events,
      eventItem,
      rssFeeds,
      notices,
      noticeItem,
      links,
      linksList,
      routes,
      isActiveModule,
    } = this.props;

    return (
      <Fragment>
        <Grid container spacing={24} justify="center" alignItems='stretch'>
          <Grid item xs={12} sm={6} md={5}>
            <Overview
              // style={{minHeight: 150}}
              title={`General ${translations.t_TITLE_ALERTS[appLanguage]}`}
              appLanguage={appLanguage}
              itemIcon={<Announcement />}
              moduleData={generalAlerts}
              route={routes.alerts}
              openState={this.state.open}
              onClick={this.handleClose}
              onOpen={this.handleOpen}
              onSelected={this.handleAlertItemSelect}
            />
          </Grid>
          {
            isActiveModule('Events') ?
          <Grid item xs={12} sm={6} md={5}>
            <Overview
              title={translations.t_TITLE_EVENTS[appLanguage]}
              appLanguage={appLanguage}
              itemIcon={<Event />}
              moduleData={events}
              route={routes.events}
              openState={this.state.open}
              onClick={this.handleClose}
              onOpen={this.handleOpen}
              onSelected={this.handleEventItemSelect}
            />
          </Grid>
          : null
          }
          {
            isActiveModule('Notices') ?
          <Grid item xs={12} sm={6} md={5}>
            <Overview
              title={translations.t_TITLE_NOTICES[appLanguage]}
              appLanguage={appLanguage}
              itemIcon={<Description />}
              moduleData={notices}
              route={routes.notices}
              openState={this.state.open}
              onClick={this.handleClose}
              onSelected={this.handleNoticeItemSelect}

            />
          </Grid>
          : null
          }
          {
            isActiveModule('rssReader') ?
            <Grid item xs={12} sm={6} md={5}>
              <Overview
                title={translations.t_MODULE_RSSREADER_TITLE[appLanguage]}
                appLanguage={appLanguage}
                itemIcon={<RssFeed />}
                moduleData={rssFeeds}
                route={routes.rssReader}
                openState={this.state.open}
                onClick={this.handleClose}
                onOpen={this.handleOpen}
              />
            </Grid>
          : null
          }
          {
            isActiveModule('Links') ?
          <Grid item xs={12} sm={6} md={5}>
            <Overview
              title={translations.t_TITLE_LINKS[appLanguage]}
              appLanguage={appLanguage}
              itemIcon={<Link />}
              moduleData={links}
              route={routes.links}
              openState={this.state.open}
              onClick={this.handleClose}
              onOpen={this.handleOpen}
            />
          </Grid>
          : null
          }
          {
            isActiveModule('linksList') ?
          <Grid item xs={12} sm={6} md={5}>
            <Overview
              title={translations.t_MODULE_LINKLIST_TITLE[appLanguage]}
              appLanguage={appLanguage}
              itemIcon={<Subject />}
              moduleData={linksList}
              route={routes.linksList}
              onOpen={this.handleOpen}
            />
          </Grid>
          : null
          }
        </Grid>
        {noticeItem.id ?
          <DetailsCardModal
            ariaLabelledby="dashboard-notice-modal-title"
            ariaDescribedby="dashboard-notice-modal-description"
            open={this.state.open}
            appLanguage={appLanguage}
            onClose={() => {
              this.handleClose();
              this.props.handleNoticeItemClose();
            }}
            title={noticeItem.header ? noticeItem.header : _filters.startEndDate(noticeItem.date, 'kamar')}
            subheader={noticeItem.header ? _filters.startEndDate(noticeItem.date) : ''}
          >
            <NoticeDetail
              noticeItem={noticeItem}
              translations={translations}
              appLanguage={appLanguage}
            />
          </DetailsCardModal>
        : eventItem.id ?
          <DetailsCardModal
            ariaLabelledby="dashboard-event-modal-title"
            ariaDescribedby="dashboard-event-modal-description"
            appLanguage={appLanguage}
            open={this.state.open}
            onClose={() => {
              this.handleClose();
              this.props.handleEventItemClose();
            }}
            title={eventItem.header}
            subheader={_filters.startEndDate(eventItem.start_ts, eventItem.end_ts)}
          >
            <EventDetail
              description={_filters.translate(eventItem.description, appLanguage)}
              location={_filters.translate(eventItem.location, appLanguage)}
              translations={translations}
              appLanguage={appLanguage}
            />
          </DetailsCardModal>
        : <DetailsCardModal
            ariaLabelledby="dashboard-alert-modal-title"
            ariaDescribedby="dashboard-alert-modal-description"
            appLanguage={appLanguage}
            open={this.state.open}
            onClose={() => {
              this.handleClose();
              this.props.handleAlertItemClose();
            }}
            title={alertItem.header}
            subheader={_filters.startEndDate(alertItem.date,alertItem.date)}
          >
            <GeneralAlertDetail
              description={_filters.translate(alertItem.description, appLanguage)}
              linkto={alertItem.linkto}
              translations={translations}
              appLanguage={appLanguage}
            />
          </DetailsCardModal>
        }
      </Fragment>
    )

  }

}

export default Home;


// WEBPACK FOOTER //
// ./src/components/Home.js